interface Props {
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
}
const StandardProductAmountDropdown = ({
  value,
  min,
  max,
  step,
  onChange,
}: Props) => {
  // Generate an array of numbers based on min, max, and step
  const generateOptions = () => {
    const options = [];
    for (let i = min; i <= max; i += step) {
      options.push(i);
    }
    return options;
  };

  const handleChange = (e: any) => {
    onChange(e.target.value);
  };

  return (
    <div className="gg-w-full gg-min-w-[90px] gg-max-w-sm">
      <div className="gg-relative">
        <select
          id="standard-product-amount-dropdown"
          value={value}
          onChange={handleChange}
          className="gg-relative gg-w-full gg-cursor-pointer gg-rounded-[1px] gg-border gg-border-r-8 gg-border-transparent gg-bg-transparent gg-py-2 gg-pl-2 gg-pr-2 gg-text-sm gg-text-dark-blue gg-outline gg-outline-1 gg-outline-dark-blue-500 placeholder:gg-text-dark-blue focus:gg-shadow-sm focus:gg-outline-none focus:gg-ring-2 focus:gg-ring-dark-blue"
        >
          {generateOptions().map((number) => (
            <option key={number} value={number}>
              {number}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
export default StandardProductAmountDropdown;
